const isDevelopmentEnv =
  process.env.NODE_ENV === 'development' || window.location.host.includes('.qa.')

const authProviderRedirect = `https://excel-add-in${
  isDevelopmentEnv ? '.qa' : ''
}.claravine.com/taskpane/auth.html`

/**
 * Available authentication providers for external applications
 * Each provider has a name, feature identifier, and redirect URL
 */
export const AUTH_PROVIDERS = {
  EXCEL: {
    name: 'Excel Add-in',
    publicApiFeatureName: 'excel',
    redirectUrl: authProviderRedirect,
    // For local development only
    // redirectUrl: 'https://localhost:3000/taskpane/auth.html',
  },
} as const
